export default __webpack_public_path__ + "static/media/mobileimg.fee16177.png";